export default {
  products: [],
  mainProducts: [],
  productDetails: {},
  allProducts: [],
  productPagination: {},
  reviews: [],
  maxPrice: 100,
}
